import React, { forwardRef } from "react";

import PropTypes from "prop-types";

import { itemCss } from "./Item.styles";

const propTypes = {
  /**
   * Node(s) to be wrapped inside li tag
   */
  children: PropTypes.any,
};

const Item = forwardRef(({ children, ...props }, ref) => {
  return (
    <li {...props} css={itemCss} ref={ref}>
      {children}
    </li>
  );
});

Item.propTypes = propTypes;
Item.displayName = "Item";
export default Item;
